const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const formattedDate = (data: number): string => {
  const fullDate = new Date(data);
  const today = new Date();

  const formattedDate =
    today.getFullYear() === fullDate.getFullYear() &&
    today.getMonth() === fullDate.getMonth() &&
    today.getDate() === fullDate.getDate()
      ? 'Today'
      : today.getFullYear() === fullDate.getFullYear() &&
        today.getMonth() === fullDate.getMonth() &&
        today.getDate() - 1 === fullDate.getDate()
      ? 'Yesterday'
      : months[fullDate.getMonth()] +
        ' ' +
        fullDate.getDate() +
        (fullDate.getDate() % 10 == 1 && fullDate.getDate() != 11
          ? 'st'
          : fullDate.getDate() % 10 == 2 && fullDate.getDate() != 12
          ? 'nd'
          : fullDate.getDate() % 10 == 3 && fullDate.getDate() != 13
          ? 'rd'
          : 'th') +
        (fullDate.getFullYear() !== today.getFullYear() ? ', ' + fullDate.getFullYear() : '');
  return formattedDate;
};

export const formatAMPM = (date: Date): any => {
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  const mminutes = minutes < 10 ? '0' + minutes : minutes;
  const strTime = hours + ':' + mminutes + ' ' + ampm;
  const preciseTime = hours + ':' + mminutes + ':' + seconds + ' ' + ampm;
  return { standard: strTime, precise: preciseTime };
};

export const timeFormat =
  ' 00:00:00' +
  (-new Date().getTimezoneOffset() > 0 ? '+' : '-') +
  String(Math.floor(Math.abs(new Date().getTimezoneOffset()) / 60)).padStart(2, '0') +
  ':' +
  String(new Date().getTimezoneOffset() % 60).padStart(2, '0');

export const getSecondsFromHHMMSS = (value: string): any => {
  const [str1, str2, str3] = value.split(':');

  const val1 = Number(str1);
  const val2 = Number(str2);
  const val3 = Number(str3);

  if (!isNaN(val1) && isNaN(val2) && isNaN(val3)) {
    return val1;
  }

  if (!isNaN(val1) && !isNaN(val2) && isNaN(val3)) {
    return val1 * 60 + val2;
  }

  if (!isNaN(val1) && !isNaN(val2) && !isNaN(val3)) {
    return val1 * 60 * 60 + val2 * 60 + val3;
  }

  return 0;
};

export const toHHMMSS = (secs: number | string): string => {
  const secNum = parseInt(secs?.toString(), 10);
  const hours = Math.floor(secNum / 3600);
  const minutes = Math.floor(secNum / 60) % 60;
  const seconds = secNum % 60;

  return [hours, minutes, seconds]
    .map((val) => (val < 10 ? `0${val}` : val))
    .filter((val, index) => val !== '00' || index > 0)
    .join(':')
    .replace(/^0/, '');
};
